import React, { useState } from "react";
import "./CardRadio.css";

const CardRadio = ({
  options,
  selectedOption,
  onOptionChange,
  childSelectedOption,
  onChildOptionChange,
}) => {
  const handleOptionChange = (event) => {
    const mainOptionValue = event.target.value;
    onOptionChange(mainOptionValue);
    const firstChildValue = options.find(
      (option) => option.value === mainOptionValue
    )?.childValue[0]?.value;
  };

  return (
    <div className="card-radio-block">
      {options.map((option) => (
        <div key={option.value}>
          <label
            className={`card-radio-group ${selectedOption === option.value ? "active" : ""
              }`}
          >
            <input
              type="radio"
              value={option.value}
              checked={selectedOption === option.value}
              onChange={handleOptionChange}
            />
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default CardRadio;
